import ButtonGradient from 'component/Buttons/dashboard-btn'
import Table from 'component/Table/table'
import { formateDate } from 'utils'
import Api from 'utils/api'
import { usePlan } from './plan.context'
import CreatePlan from './create.plan'
import EditIcon from 'icon/editIcon'
import { Tooltip } from 'react-tooltip'
import DeleteIcon from 'icon/delete'

const Headers = [
  { name: 'Created', accessor: 'created' },
  { name: 'Plan Name', accessor: 'name' },
  { name: 'Currency', accessor: 'currency' },
  { name: 'Amount', accessor: 'amount' },
  { name: 'Custom Plan', accessor: 'custom' },
  { name: 'Hours', accessor: 'hoursLimit' },
  { name: 'View', accessor: 'view' },
  { name: 'Actions', accessor: 'actions' },
]

function Plans() {
  const { plans, setOpenModal, setSelectedPlan, setShowConfirmDelete } =
    usePlan()

  const handleUpdate = (plan) => {
    setSelectedPlan(plan)
    setOpenModal(true)
  }

  const handleDelete = (plan) => {
    setShowConfirmDelete(true)
    setSelectedPlan(plan)
  }

  const Rows = plans.map((plan) => ({
    created: formateDate(plan.createdAt),
    currency: plan?.currency,
    amount: plan?.amount,
    custom: plan?.customizedPlan ? 'True' : 'false',
    hoursLimit: plan?.hoursLimit || '-',
    name: <div className='capitalize'>{plan?.productname}</div>,
    view: (
      <div className='flex items-center'>
        <div
          onClick={() => handleUpdate(plan)}
          class='font-medium cursor-pointer text-blue-600 dark:text-blue-500 hover:underline'
        >
          View
        </div>
      </div>
    ),
    actions: (
      <div className='flex items-center'>
        {/* <Link
          to={'./details'}
          state={customer}
          data-tooltip-id='view'
          data-tooltip-content='View Details'
          class='font-medium mr-4 cursor-pointer'
        >
          <EyeOpenIcon />
          <Tooltip id='view' />
        </Link> */}
        <div
          data-tooltip-id='edit'
          data-tooltip-content='Edit'
          class='font-medium cursor-pointer'
          onClick={() => handleUpdate(plan)}
        >
          <EditIcon size={16} />
          <Tooltip id='edit' />
        </div>

        <div
          data-tooltip-id='delete'
          data-tooltip-content='Delete'
          onClick={() => handleDelete(plan)}
          class='font-medium ml-4 cursor-pointer'
        >
          <DeleteIcon size={16} />
          <Tooltip id='delete' />
        </div>
      </div>
    ),
  }))

  return (
    <div>
      <div class=' gap-4 items-center  '>
        <div class='flex justify-between items-center mb-3'>
          <h1 class='mb-4 text-2xl font-extrabold text-gray-900  md:text-5xl lg:text-5xl'>
            <span class='text-transparent bg-clip-text bg-gradient-to-br from-[#90AFEC]  to-[#234E70]'>
              Plans
            </span>
          </h1>

          <ButtonGradient
            disabled={false}
            label={'Create'}
            onClick={() => {
              setOpenModal(true)
            }}
          />
        </div>
      </div>
      <hr />

      <CreatePlan />

      <div class='mt-6'>
        <Table columns={Headers} rows={Rows} />
      </div>
    </div>
  )
}

export default Plans
